module.exports = __webpack_public_path__ + "static/img/test.dbbe693.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/product/test.png
// module id = R/P4
// module chunks = 1